<template>
  <div class="nav-bar">
    <div class="nav-bar-container">
      <h1 class="nav-bar-title">Help Center</h1>
      <div class="nav-bar-close" @click="closeWindow">
        <img :src="closeSrc" alt="close" />
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('common');
import sdk from '@/lib/sdk';

export default {
  name: 'containerNavbar',
  data() {
    return {
      lightClose: require('@/assets/image/light/icon_close_title.svg'),
      darkClose: require('@/assets/image/dark/icon_close_title.svg'),
    };
  },
  computed: {
    ...mapState(['isDark']),
    closeSrc() {
      return this.isDark ? this.darkClose : this.lightClose;
    }
  },
  methods: {
    closeWindow() {
      try {
        sdk.closeWindow();
      } catch(e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-bar {
  &-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 16px;
    background-color: var(--current-detail-bg-color);
    height: 42px;
    border-radius: 2px 2px 0px 0px;
    border-bottom: 1px solid var(--current-search-border-color);
  }

  &-title {
    color: var(--current-default-color);
    font-size: 12px;
  }

  &-close {
    padding: 2px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    
    &:hover {
      background: var(--current-bg-hover-color);
      border-radius: 2px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/container-navbar/index.vue